import React from 'react';
import { useExportQueue } from '../contexts/ExportQueueContext';
import ExportProgressTracker from './ExportProgressTracker';

/**
 * GlobalExportProgressTracker
 * Wraps ExportProgressTracker with global context
 * Shows on ALL pages, persists across navigation
 */
const GlobalExportProgressTracker = () => {
  const { exportQueue, downloadExport, removeExport } = useExportQueue();

  return (
    <ExportProgressTracker
      exports={exportQueue}
      onDownload={downloadExport}
      onDismiss={removeExport}
    />
  );
};

export default GlobalExportProgressTracker;
